import React from 'react';
import { Box, Typography } from '@mui/material';
import { storageService } from '../../services/storageService';
import { permissionService } from '../../services/permissionService';
import { UserUtils } from '../../helpers/userUtils';
import { RoleType, getRoleString } from '../../models/enums/roleType';

export const HomeHeader: React.FC = () => {
    const user = storageService.getUserData();
    const userFio = user ? UserUtils.getFio(user) : '';
    const roles = permissionService.getRoles();

    const getRoleName = (): string => {
        if (roles.length === 0) {
            return getRoleString(RoleType.Undefined);
        }

        // Приоритет ролей для сортировки: Admin > Medic > Dispatcher > Driver
        const rolePriority: Record<RoleType, number> = {
            [RoleType.Admin]: 1,
            [RoleType.Medic]: 2,
            [RoleType.Dispatcher]: 3,
            [RoleType.Driver]: 4,
            [RoleType.Undefined]: 5,
        };

        // Сортируем роли по приоритету и преобразуем в строки
        const sortedRoles = roles
            .sort((a, b) => (rolePriority[a] || 99) - (rolePriority[b] || 99))
            .map(role => getRoleString(role));

        return sortedRoles.join(', ');
    };

    const roleName = getRoleName();

    return (
        <Box sx={{ mb: 4 }}>
            {userFio && (
                <Typography variant="body1" sx={{ mb: 0.5, color: '#2A2932', fontWeight: 700 }}>
                    Здравствуйте, {userFio}!
                </Typography>
            )}

            <Typography variant="body2" sx={{ color: '#2A2932' }}>
                Ваша роль в системе: {roleName}
            </Typography>
        </Box>
    );
};

